import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { UserContext } from "../UserContext";

const Home = () => {
  const [user] = useContext(UserContext);
  const history = useHistory();
  useEffect(() => {
    if (user.role === "unauthenticated") {
      history.push("/");
    }
  });
  return (
    <Container>
      <Section>
        <h3>Account Number</h3>
        <h4>{user.acc_no}</h4>
      </Section>
      <Section>
        <h3>Current Balance</h3>
        <h4>${user.balance}</h4>
      </Section>
    </Container>
  );
};
const Container = styled.div``;
const Section = styled.div`
  margin: 1em;
`;
export default Home;
